import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import zhTranslation from './locales/zh/translation.json';
import msTranslation from './locales/ms/translation.json';

// Basic language persistence using localStorage
const storedLang = typeof window !== 'undefined' ? (localStorage.getItem('appLanguage') || 'en') : 'en';

const resources = {
  en: { translation: enTranslation },
  zh: { translation: zhTranslation },
  ms: { translation: msTranslation },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: storedLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    keySeparator: '.',
    supportedLngs: ['en', 'zh', 'ms'],
    detection: { order: ['localStorage', 'navigator'] },
  });

export default i18n;


